import { Alert, Box, Collapse, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import Capa from "../../Controls/Capa/Capa";
import { getLeyendaList } from "../../../Service/leyenda";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { getImageTipoList, getPosicionImgList } from "../../../Service/imagen";
import { addLeyendaImg, frmUpdateLeyendasImgOc } from "../../../Service/leyendasImg";

export default function LeyendaImgView(props) {

    const { accessToken } = useContext(AuthContext);
    const [leyendas, setLeyendas] = useState([]);
    const [imagenes, setImagenes] = useState([]);
    const [posiciones, setPosiciones] = useState([]);
    const [loading, setLoading] = useState(false);
    const [valCodLeyenda, setCodLeyendaValue] = useState('')
    const [valStream_id, setStream_id] = useState('')
    const [valCodImgPosicion, setCodImgPosicion] = useState('')

    //DIALOG METODOS MSJ ********************
    //Open Close
    const [openMsj, setOpenMsj] = useState(false)
    //Msj Error
    const [msjTitle, setMsjTitle] = useState("")

    const MsjElement = ({severityProp}) => {
      return (
            <Collapse in={openMsj}>
              <Alert severity={severityProp} onClose={()=>{setOpenMsj(false)}}>
                {msjTitle}
              </Alert>
            </Collapse>
          );
    };

    //DIALOG METODOS MSJ ********************

    useEffect(() => {

        setLoading(true);
        getLeyendaList(accessToken)
            .then((data) => {
                setLeyendas(data);
            })
            .catch()
            .finally(() => setLoading(false))

        setLoading(true);

        getImageTipoList(accessToken, 'L')
            .then((data) => {
                setImagenes(data);
            })
            .catch()
            .finally(() => setLoading(false))

        setLoading(true);

        getPosicionImgList(accessToken)
            .then((data) => {
                setPosiciones(data);
            })
            .catch()
            .finally(() => setLoading(false))


            if(props.dataEdit != undefined && props.dataEdit.CodLeyendaFirma != 0){
                
                setCodLeyendaValue(props.dataEdit.CodLeyenda);
                setStream_id(props.dataEdit.stream_id);
                setCodImgPosicion(props.dataEdit.CodImgPosicion);
                //setPosicion(props.dataEdit.CodFirmaPosicion);

            }

    }, []);

    const codLeyendaChange = (event) => {
        setCodLeyendaValue(event.target.value);
    };

    const stream_idChange = (event) => {
        setStream_id(event.target.value);
    };

    const codImgPosicionChange = (event) => {
        setCodImgPosicion(event.target.value);
    };

    const onAceptar = (e) => {
        e.preventDefault();

        const formData = new FormData(e.currentTarget);

        //tomo las descripciones para ser mostradas en la grilla
        const selectedLeyenda = leyendas.find((option) => option.CodLeyenda == formData.get("CodLeyenda"))?.DescLey;
        const selectedImagen = imagenes.find((option) => option.stream_id == formData.get("uniqueidentifier"))?.Descripcion;
        const selectedPosicion = posiciones.find((option) => option.CodImgPosicion == formData.get("CodImgPosicion"))?.Descripcion;

        
        if(props.dataEdit != undefined && props.dataEdit.CodLeyendaImg != undefined && props.dataEdit.CodLeyendaImg != 0){
            //Edit
            const frmUpdateLeyendasImgOcRequest = Object.fromEntries(formData);
            const datos = { frmUpdateLeyendasImgOcRequest }
            datos.frmUpdateLeyendasImgOcRequest.CodLeyendaImg = props.dataEdit.CodLeyendaImg; 

            frmUpdateLeyendasImgOc(datos, accessToken)
            .then(data => {
                if(data != undefined && data.Message != undefined && data.Message.includes("Error")){
                    setMsjTitle(data.Message);
                    setOpenMsj(true);    
                    return;
                }else{
                    //const dataNew = { ...datos.frmUpdateLeyendasFirmasSocRequest, DescLeyenda: selectedLeyenda, DescImagen: selectedFirma, DescPosicion: selectedPosicion, CodLeyendaFirma: props.dataEdit.CodLeyendaFirma };
                    //props.setData(dataNew);
                    props.pInit();
                    props.handleClose();                    
                }
            }).catch(
                error => { 
                    setMsjTitle(error.toString());
                    setOpenMsj(true);
                }); 

        }else{
            //New
            const frmInsertLeyendasImgOcRequest = Object.fromEntries(formData);
            const datos = { frmInsertLeyendasImgOcRequest }

            addLeyendaImg(datos, accessToken)
            .then(data => {
                if(data.Message != undefined && data.Message.includes("Error")){
                    setMsjTitle(data.Message);
                    setOpenMsj(true);    
                    return;
                }else{
                    //const dataNew = { ...datos.frmInsertLeyendasFirmasSocRequest, DescLeyenda: selectedLeyenda, DescImagen: selectedFirma, DescPosicion: selectedPosicion, CodLeyendaFirma: data.CodLeyendaFirma };
                    //props.setData(dataNew);
                    props.pInit();
                    props.handleClose();                    
                }
            }).catch(
                error => { 
                    setMsjTitle(error.toString());
                    setOpenMsj(true);
                }); 
        }


        // addLeyendaImg(datos, accessToken)
        //     .then(data => {

        //         const dataNew = { ...datos.FrmInsertLeyendasImgOCRequest, DescLeyenda: selectedLeyenda, DescImagen: selectedImagen, DescPosicion: selectedPosicion, CodLeyendaImg: data.CodLeyendaImg };
        //         props.setData(dataNew);

        //         props.handleClose();
        //     })

    }


    return (
        <Box component={'form'} onSubmit={onAceptar}>
            <Capa onCancel={props.handleClose} title={"Leyenda - Logo"}>
                <FormControl fullWidth required>
                    <InputLabel id="leyenda-select-label">Leyenda</InputLabel>
                    <Select
                        labelId="leyenda-select-label"
                        id="leyenda-select"
                        value={valCodLeyenda}
                        label="Leyenda"
                        onChange={codLeyendaChange}
                        sx={{ m: 1 }}
                        name="CodLeyenda"
                    >
                        {leyendas.map((option) => (
                            <MenuItem key={option.DescLey} value={option.CodLeyenda}>
                                {option.DescLey}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth required>
                    <InputLabel id="imagen-select-label">Logo</InputLabel>
                    <Select
                        labelId="imagen-select-label"
                        id="imagen-select"
                        value={valStream_id}
                        label="Imagen"
                        onChange={stream_idChange}
                        sx={{ m: 1 }}
                        name="uniqueidentifier"
                    >
                        {imagenes.map((option) => (
                            <MenuItem key={option.Descripcion} value={option.stream_id}>
                                {option.Descripcion}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth required>
                    <InputLabel id="posicion-select-label">Posición</InputLabel>
                    <Select
                        labelId="posicion-select-label"
                        id="posicion-select"
                        value={valCodImgPosicion}
                        label="Posicion"
                        onChange={codImgPosicionChange}
                        sx={{ m: 1 }}
                        name="CodImgPosicion"
                    >
                        {posiciones.map((option) => (
                            <MenuItem key={option.Descripcion} value={option.CodImgPosicion}>
                                {option.Descripcion}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <MsjElement severityProp="error"></MsjElement>   
            </Capa>

        </Box>
    );

};